module.exports = __webpack_public_path__ + "static/media/slidee-2.d8cbeab0.jpg";